import uniqueId from "lodash/uniqueId";
import { CreateVideoSequenceTrackWithM3U8Content, CreateVideoSequenceTrack } from "@/util/EditUtil";
import store from "@/Redux";

const segmentText = (text, numPerLine) => {
    if (text.length <= numPerLine) {
        return text;
    }
    let distText = "";
    let line = "";
    for (let i = 0; i < text.length; i++) {
        line += text[i];

        if (i > 0 && i % numPerLine == 0) {
            distText += line + "\n";
            line = "";
        }
    }
    distText += line;

    return distText;
}


const getAllSubtitleTrack = (subtitleJson, editSize, trackManager) => {

    let {editorManager} = trackManager;
    let sxTrackGroup = editorManager.addGroupAtIndex(1),
        id = uniqueId("track-group");
    let trackList = []
    let SXTextAlignmentType = window["SXTextAlignmentType"];
    let { groupList, currentDragItem, allMediaBeforeDuration } = trackManager
    let subtitleTrackIndex = -1
    groupList.forEach((v, i) => {
        if (v.trackList && v.trackList[0].isSubtitleTrack) {
            subtitleTrackIndex = i
            sxTrackGroup = v.sxTrackGroup
            trackList = v.trackList
        }
    })
    subtitleJson.map(v => {
        let sxTrack = editorManager.createTextTrack((v.EndTime - v.BeginTime) / 1000);
        sxTrack.setFontFile("/material/font/SourceHanSansCN-Medium.ttf");
        sxTrack.setFillColor("#ffffff");
        sxTrack.setFontSize(24);
        // 文本自适应 简单适配 假定文本不会超过80个字符
        // 位置自适应，预留4行的位置
        sxTrack.setPosition(editSize[0] / 2, editSize[1] - 80);

        // 每行最多 20 个字符
        // v.Text = "美国前总统唐纳德·特朗普在华盛顿地区法院对美国国会众议院特别委员会提起诉讼，试图阻止特别委员会调取1月6日国会大厦骚乱事件的相关文件。"
        let distText = segmentText(v.Text, 20);
        sxTrack.setContent(distText);

        // 居中对齐
        sxTrack.setAlignment(SXTextAlignmentType.kAlignCenter)

        // 描边
        sxTrack.setStrokeWidth(2);
        sxTrack.setStrokeColor("#000000");
        sxTrackGroup.addTrack(sxTrack, v.BeginTime / 1000);
        sxTrack.setDuration((v.EndTime - v.BeginTime) / 1000);
        sxTrack.setOffsetTime(v.BeginTime / 1000);
        sxTrack.moveToTime(currentDragItem.startTime + v.BeginTime / 1000);

        var obj = {
            id: v.trackId_text,
            pid: id,
            duration: (v.EndTime - v.BeginTime) / 1000,
            scale: [1, 1],
            startTime: currentDragItem.startTime + v.BeginTime / 1000,
            isSubtitleTrack: true,
            sxTrack,
            text: '字幕轨道',
            trackId: sxTrack.getTrackId(),
            type: 1,
            textInfoObj: {
                align: 0,
                content: v.Text,
                fontSize: 14,
                strokeWidth: 1,
                textColor: "#fff",
                wordSpace: 1,
            }
        }
        allMediaBeforeDuration[v.trackId_text] = obj.duration

        trackList.push(obj)


    })
    trackList.sort(function (a, b) { return a.BeginTime - b.BeginTime })
    let appendData = {
        type: 1,
        BoundingClientRect: null,
        currentTrack: false,
        isShowBottomLine: false,
        isShowTopLine: false,
        id,
        sxTrackGroup,
        trackList
    }
    if (subtitleTrackIndex === -1) {
        groupList.push(appendData)
    } else {
        groupList[subtitleTrackIndex] = appendData
    }
    store.dispatch({
        type: 'ChangeProperty',
        propertyName: 'groupList',
        payload: {
            data: Object.assign([], groupList)
        }
    })
    store.dispatch({
        type: 'ChangeProperty',
        propertyName: 'allMediaBeforeDuration',
        payload: {
            data: Object.assign([], allMediaBeforeDuration)
        }
    })
    return appendData
}
//补齐主轨道
const addAndSortList = (arr, endTime) => {
    let currentEnd = endTime * 1000
    let newarr = []
    //先生成中间的对象，然后生成两头的，最后进行排序
    for (var i = 0; i < arr.length - 1; i++) {
        if (arr[i].EndTime !== arr[i + 1].BeginTime) {
            let obj = {
                BeginTime: arr[i].EndTime,
                EndTime: arr[i + 1].BeginTime,
                text: '',
                trackId_main: uniqueId('mainTrack')
            }

            newarr.push(obj)
        }
    }
    let newArr = arr.concat(newarr)
    let minDuration = Math.min.apply(Math, newArr.map(function (o) { return o.BeginTime }))
    let maxDuration = Math.max.apply(Math, newArr.map(function (o) { return o.EndTime }))
    if (minDuration !== 0) {
        let obj = {
            EndTime: minDuration,

            BeginTime: 0,
            Text: "",
            trackId_main: uniqueId('mainTrack')
        }
        newArr.unshift(obj)
    }
    if (maxDuration !== currentEnd) {
        let obj = {
            EndTime: currentEnd,

            BeginTime: maxDuration,
            Text: "",
            trackId_main: uniqueId('mainTrack')
        }
        newArr.push(obj)
    }
    newArr.sort(function (a, b) { return a.BeginTime - b.BeginTime })
    return newArr
}

const getAllVideo = (list, trackManager, mainTrackManager) => {
    let { currentDragItem, editorManager } = trackManager,
        { mainTrack, currentStartTime, mainComposite, mainCompositeTrack, mainInternalGroup } = mainTrackManager,
        position = currentDragItem.videoTrack.getPosition(),
        scale = currentDragItem.videoTrack.getScale(),
        { currentDrag } = currentDragItem;
    list = addAndSortList(list, currentDragItem.duration)
    currentDragItem.startTime = currentDragItem.startTime || 0

    list.map((v, i) => {
        let tempobj = Object.assign({}, currentDragItem)
        delete tempobj['currentDrag']
        tempobj.duration = (v.EndTime - v.BeginTime) / 1000
        let isMainTrack = true;
        var createVideoTrackPromise = CreateVideoSequenceTrack({ currentDrag, editorManager, mainComposite, isMainTrack });
        
        createVideoTrackPromise.then((ret) => {
            let { videoTrack, delegate } = ret;
            currentDrag.duration = (v.EndTime - v.BeginTime) / 1000
            videoTrack.setPosition(position[0], position[1]);
            videoTrack.setScale(scale[0], scale[1])
            // 添加轨道到 group 的指定时间点
            mainInternalGroup.addTrack(videoTrack, (v.BeginTime / 1000));
            // 设置时长
            videoTrack.setDuration(currentDrag.duration);
            // 设置视频偏移时间
            videoTrack.setOffsetTime(v.BeginTime / 1000);
            // 重置时间到添加点
            videoTrack.moveToTime(currentDragItem.startTime + v.BeginTime / 1000);
            // console.log("track displayTime", videoTrack.getStartTime(), videoTrack.getDisplayTime(), "offsetTime", videoTrack.getOffsetTime(), "duration", videoTrack.getDuration())

            let appendData = {
                currentDrag: Object.assign({}, currentDrag),
                index: -1,
                scale: [scale[0], scale[1]],
                startTime: currentDragItem.startTime + v.BeginTime / 1000,
                videoDelegate: delegate,
                videoTrack,
                rotation: 0,
                id: v.trackId_main,
                isSplit: true,
                isShowBeginTime: true, //根据该字段控制beforeDuration存duration还是begintime
            }

            //保存到reudx以供导出视频使用
            let material = {
                path: delegate.sequenceString,
                url: currentDrag.mp4_url,
                type: currentDrag.type_id,
                category_id: currentDrag.category_id,
            }
            currentDragItem.duration  = currentDrag.duration
       
            store.dispatch({ type: 'mainTrackAppendItem', payload: appendData })
            store.dispatch({ type: 'addMaterialItemAction', payload: [material] })
            if (i === list.length - 1) {
                store.dispatch({
                    type: "removeMainTrack", payload: {
                        data: currentDragItem,
                        replacBeforeTrack: true,
                        currentTime: trackManager.currentTime
                    }
                })
            }


        })
    })

  


}

export {
    getAllSubtitleTrack,
    getAllVideo,
    segmentText
}